var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWhiteboardHide = function SvgWhiteboardHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47 5.47a.75.75 0 0 1 1.06 0L12 7.94l2.47-2.47a.75.75 0 1 1 1.06 1.06L13.06 9l2.47 2.47a.75.75 0 1 1-1.06 1.06L12 10.06l-2.47 2.47a.75.75 0 0 1-1.06-1.06L10.94 9 8.47 6.53a.75.75 0 0 1 0-1.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 15.75h-4.846l2.531 5.695a.75.75 0 0 1-1.37.61l-2.802-6.305H9.487l-2.802 6.305a.75.75 0 0 1-1.37-.61l2.53-5.695H3a1.5 1.5 0 0 1-1.5-1.5V3.75A1.5 1.5 0 0 1 3 2.25h18a1.5 1.5 0 0 1 1.5 1.5v10.5a1.5 1.5 0 0 1-1.5 1.5Zm-18-12h18v10.5H3V3.75Z"
  })));
};
export default SvgWhiteboardHide;